import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { saveAs } from 'file-saver';
import * as XLSX from '../../../xlsx';
import { APIRequestOptions } from '../../communication-structure/api-request';
import { CommunicationProxyService } from '../../services/communication-proxy.service';
import { SheetjsHelperService } from '../../services/sheetjs-helper.service';
import { StringTableService } from '../../services/string-table.service';
import { BaseComponent } from '../base/base.component';
import { ChckboxComponent, CheckboxState } from '../chckbox/chckbox.component';
import { MainComponent } from '../main-component/main.component';
import { qstnResponseStatus } from '../page-view/page-view.component';
import { Table, Types } from '../table/table.component';

@Component({
  selector: 'app-popup-table',
  templateUrl: './popup-table.component.html',
  styleUrls: ['./popup-table.component.scss']
})

export class PopupTableComponent extends BaseComponent implements OnInit {
  csvFilename: string;
  xlsxFilename: string;
  pdfFilename: string;
  headerColor: string;
  noOfColumns: any;
  subTablesData: any[];
  wrongCheckIcon: string;
  checkIcon: string;
  plusSignIcon: string;
  minusSignIcon: string;
  downArrowClass: string;
  upArrowClass: string;
  detailsHeader: any;
  secondaryTableHeaders: string[];
  isExcelDownloadInProgress = false;
  isPdfDownloadInProgress = false;
  activeDownloads = {};
  public colspan: number;
  public expandList: Array<boolean>;
  public NotNullList: Array<number>;
  public listExplanded: boolean;
  private isAllChecked = false;
  public detailTable: Table[][];

  public pageNumber = 0;
  public numberOfTask = 0;

  public selectedRows: Array<number>;
  public selectedRowNumer: number;
  public subTableShow = false;
  public listExpandIcoClass = '';
  public correctLabel: string;
  public inCorrectLabel: string;
  public incompleteLabel: string;
  public expandSubTable: Array<boolean>;
  public listExpanded = false;
  private tableRowsForExcel: Table[][] = [];
  private dataForSheetJs: any[][];
  private headerHexColorName = '';
  private xlsxWritingOptions: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  private currentSkillId;
  @Input() table: Table[][];
  @Input() hasClickStream = false;
  @Input() subTableToDisplayed: any[];

  @Input() header: Array<Table>;
  @Input() subTableHeader: Array<Table>;
  @Input() isPaginator = false;

  @Output() buttonClicked: EventEmitter<object> = new EventEmitter();

  @Output() linkClicked: EventEmitter<object> = new EventEmitter();

  @Input() tableLength = 0;

  @Input() popupTableData: any;

  @Output() checkboxClicked: EventEmitter<Array<number>> = new EventEmitter();

  @ViewChildren('checkBox') private checkBox;

  @ViewChild('popupTable') popupTable;

  @ViewChild('headerCheckBox') headerCheckbox: ChckboxComponent;

  constructor(ele: ElementRef,
    protected stringTableService: StringTableService,
    private sheetjsHelper: SheetjsHelperService,
    protected remoteProxy: CommunicationProxyService) {
    super(ele);
    this.selectedRows = [];
    this.detailTable = [];
  }

  ngOnInit() {
    this.correctLabel = this.stringTableService.getString('report-courses', 'correct');
    this.inCorrectLabel = this.stringTableService.getString('report-courses', 'incorrect');
    this.incompleteLabel = this.stringTableService.getString('report-courses', 'incomplete');
    this.upArrowClass = this.stringTableService.getString('icons', 'triangle-up');
    this.downArrowClass = this.stringTableService.getString('icons', 'triangle-down');
    this.checkIcon = this.stringTableService.getString('icons', 'check');
    this.wrongCheckIcon = this.stringTableService.getString('icons', 'x');
    this.plusSignIcon = this.stringTableService.getString('paths', 'plusSignIcon');
    this.minusSignIcon = this.stringTableService.getString('paths', 'MinusSignIcon');
    this.headerColor = this.stringTableService.getString('popups', 'headerColor');
    this.xlsxFilename = this.stringTableService.getString('popups', 'xlsxFileName');
    this.csvFilename = this.stringTableService.getString('popups', 'csvFilename');
    this.pdfFilename = this.stringTableService.getString('popups', 'pdfFilename');
    this.secondaryTableHeaders = this.stringTableService.getArrayOfStrings('popups', 'secondaryTableHeaders');
    this.subTableHeader = this.setTableHeaders(this.secondaryTableHeaders);
    this.generateEmptySubTableList(200);
    this.generateEmptyExpandList(200);
  }

  generateEmptySubTableList(length) {
    this.expandSubTable = [];
    this.subTablesData = [];
    this.NotNullList = [];
    for (let i = 0; i < length; i++) {
      this.expandSubTable.push(false);
      this.subTablesData.push(null);
    }
  }

  onClick(type: Types, id: number, title: string) {
    switch (type) {
      case 1: {
        this.buttonClicked.emit({ tableRow: this.table[id], buttonClickedTitle: title, index: id });
      }
        break;
    }
  }

  getCheckboxes() {
    return this.checkBox.toArray();
  }

  onCheckBoxClicked(event, index) {
    const allCheckBoxes = this.checkBox.toArray();
    if (event.checkboxState === CheckboxState.CHECKED) {
      if (index === -1) {
        this.checkAll(true, allCheckBoxes);
      } else {
        if (this.isAllCBManuallyChecked(allCheckBoxes) && this.headerCheckbox) {
          this.headerCheckbox.isSelected = true;
        }
        this.selectedRows.push(index);
      }
    } else if (event.checkboxState === CheckboxState.UNCHECKED) {
      if (index === -1) {
        this.checkAll(false, allCheckBoxes);
      } else {
        if (this.isAllChecked && this.headerCheckbox) {
          this.headerCheckbox.isSelected = false;
        }
        this.selectedRows.splice(this.selectedRows.indexOf(index), 1);
      }
    }
    this.checkboxClicked.emit(this.selectedRows.sort());
  }

  onLinkClicked(id: number) {
    this.linkClicked.emit(this.table[id]);
  }

  onPageChange(pageNumber) {
    this.pageNumber = pageNumber;
  }

  isAllCBManuallyChecked(allCheckBoxes): boolean {
    let checkCount = 0;
    for (let i = 0; i < allCheckBoxes.length; i++) {
      if (allCheckBoxes[i].isSelected) {
        ++checkCount;
      }
    }
    if (checkCount === allCheckBoxes.length) {
      this.isAllChecked = true;
      return true;
    }
    return false;
  }

  checkAll(boolVal, allCheckBoxes) {
    this.selectedRows = [];
    allCheckBoxes.forEach((checkbox) => {
      if (checkbox.isEnable) {
        checkbox.isSelected = boolVal;
      }
    });
    for (let i = 0; i < this.table.length; i++) {
      if (boolVal) {
        this.selectedRows.push(i);
      } else {
        this.selectedRows.splice(this.selectedRows.indexOf(i), 1);
      }
    }
    this.isAllChecked = boolVal;
  }

  showsubtable(rawNumber) {
    if (this.expandSubTable[rawNumber]) {
      this.expandSubTable[rawNumber] = false;
    } else {
      this.expandSubTable[rawNumber] = true;
      this.subTablesData[rawNumber] = this.generateSubtable(this.table[rawNumber][9].title);
      this.colspan = this.table[0].length;
    }
  }

  expanedAllList() {
    const isExpanded = this.isAnyListExpanded();
    for (let i = 0; i < this.NotNullList.length; i++) {
      this.expandList[this.NotNullList[i]] = !isExpanded;
    }
  }

  expanedList(rawNumber) {
    if (this.expandList[rawNumber]) {
      this.expandList[rawNumber] = false;
    } else {
      this.expandList[rawNumber] = true;
    }
  }

  generateEmptyExpandList(length) {
    this.expandList = [];
    for (let i = 0; i < length; i++) {
      this.expandList.push(false);
    }
  }

  generateSubtable(subtable) {
    let index = 0;
    this.numberOfTask = subtable.length;
    this.detailTable = [];
    this.secondaryTableHeaders = this.stringTableService.getArrayOfStrings('popups', 'secondaryTableHeaders');
    this.subTableHeader = this.setTableHeaders(this.secondaryTableHeaders);
    for (const tasklistTable of subtable) {
      this.detailTable.push([
        new Table(Types.TEXT, 'table-data', ++index),
        new Table(Types.TEXT, 'table-data', tasklistTable.taskName),
        new Table(Types.TEXT, 'table-data', this.setQueState(tasklistTable.status)),
        new Table(Types.TEXT, 'table-data', this.convertTime(tasklistTable.timeTaken, ':')),
        new Table(Types.MINMAX_LIST, 'tg-arrow-up2', tasklistTable.clickstreams)
      ]);
    }
    return this.detailTable;
  }

  setTableHeaders(data) {
    const headerArray = [];
    for (const header of data) {
      const headerData = {
        title: header.name,
        type: header.type,
        class: 'table-header'
      };
      headerArray.push(headerData);
    }
    return headerArray;
  }
  convertTime(input, separator) {
    return [
      this.pad(Math.floor(input / 3600)),
      this.pad(Math.floor(input % 3600 / 60)),
      this.pad(Math.floor(input % 60)),
    ].join(typeof separator !== 'undefined' ? separator : ':');
  }

  pad(input) {
    return input < 10 ? '0' + input : input;
  }

  setQueState(status) {
    let statesText: string;
    if (qstnResponseStatus.Correct === status || status === 4) {
      statesText = this.correctLabel;
    } else if (qstnResponseStatus.Skipped === status || qstnResponseStatus.Incomplete === status) {
      statesText = this.incompleteLabel;
    } else {
      statesText = this.inCorrectLabel;
    }

    return statesText;
  }

  isSubTableExpanded(num) {
    if (this.expandSubTable[num]) {
      return true;
    } else {
      return false;
    }
  }

  isListExpanded(num) {
    if (this.expandList[num]) {
      return true;
    } else {
      return false;
    }
  }

  isAnyListExpanded() {
    for (let i = 0; i < this.NotNullList.length; i++) {
      if (this.expandList[this.NotNullList[i]]) {
        return true;
      }
    }
    return false;
  }

  getArrowClaa(i) {
    if (this.isSubTableExpanded(i)) {
      return this.upArrowClass;
    } else {
      return this.downArrowClass;
    }
  }

  isNullList(list, rowNum) {
      if (list.length > 0) {
        this.NotNullList.push(rowNum);
      }
      return list.length <= 0;
  }

  getSkillBulletClass(crt) {
    if (crt === 1) {
      return this.checkIcon;
    } else {
      return this.wrongCheckIcon;
    }
  }

  saveTocsv(i) {
    let table: Table[][] = [];
    this.subTablesData[i] = this.generateSubtable(this.table[i][9].title);
    table = this.copyTable(this.subTablesData[i]);
    const headerClone = JSON.parse(JSON.stringify(this.subTableHeader));
    this.noOfColumns = 7;
    this.noOfColumns = headerClone.length;
    this.dataForSheetJs = this.sheetjsHelper.parseDataForSheetJs([headerClone], this.noOfColumns);
    if (table.length > 0) {
      if (table[0][4].type === 13) {
        this.tableRowsForExcel = this.convertTableArrayIntoString(table);
      }
    }
    const dataForCsv = [];
    // Adding table header for Csv
    const headerForCsv = {};
    for (const row of headerClone) {
      if (!headerForCsv[row.title]) {
        headerForCsv[row.title] = row.title;
      }
    }
    dataForCsv.push(headerForCsv);
    // Adding table data for Csv
    for (const row of this.tableRowsForExcel) {
      const tableRow = {};
      for (const data of row) {
        if (!tableRow[data.title]) {
          tableRow[data.title] = data.title;
        }
      }
      dataForCsv.push(tableRow);
    }
    // tslint:disable-next-line:no-unused-expression
    new Angular5Csv(dataForCsv, this.csvFilename);
  }

  saveToXls(i) {
    if ( !this.currentSkillId ) {
      this.setCurrentSkillId();
    }

    const skillId = this.currentSkillId;
    this.isExcelDownloadInProgress = true;
    this.activeDownloads[skillId].excel = true;
    let table: Table[][] = [];
    this.subTablesData[i] = this.generateSubtable(this.table[i][9].title);
    table = this.copyTable(this.subTablesData[i]);
    const headerClone = JSON.parse(JSON.stringify(this.subTableHeader));
    this.noOfColumns = 7;
    this.noOfColumns = headerClone.length;
    this.dataForSheetJs = this.sheetjsHelper.parseDataForSheetJs([headerClone], this.noOfColumns);
    if (table.length > 0) {
      if (table[0][4].type === 13) {
        this.tableRowsForExcel = this.convertTableArrayIntoString(table);
      }
      this.dataForSheetJs.splice(1, this.dataForSheetJs.length);
      const tableClone = JSON.parse(JSON.stringify(this.tableRowsForExcel));
      Array.prototype.push.apply(this.dataForSheetJs, this.sheetjsHelper.parseDataForSheetJs(tableClone, this.noOfColumns));

      const titles = [];
      this.popupTableData.skillList.forEach( skill => {
        titles.push( skill.skillName );
      });

      const workSheet = this.sheetjsHelper.prepareSheet(this.dataForSheetJs, this.noOfColumns);
      const workBook = this.sheetjsHelper.prepareWorkBook([workSheet], this.headerColor, titles);
      this.sheetjsHelper.downloadSheet(workBook, this.xlsxWritingOptions, this.xlsxFilename);
    } else {
      console.log('in else');
    }
    this.isExcelDownloadInProgress = false;
    this.activeDownloads[skillId].excel = false;
  }

  saveTopdf(i) {
    if ( !this.currentSkillId ) {
      this.setCurrentSkillId();
    }

    const skillId = this.currentSkillId;
    this.isPdfDownloadInProgress = true;
    this.activeDownloads[skillId].pdf = true;
    const generatePdfReportEndPoint = this.stringTableService.getEndpoint('GeneratePdfReport');

    const skillList = [];
    let taskList = [];

    this.popupTableData.skillList.forEach(skill => {
      const skillTasks = MainComponent.getTrainingList().find(record => record.skillId === skill.skillId).taskList;
      taskList = taskList.concat( skillTasks );

      skillList.push( {
        skillId: skill.skillId,
        applicationName: skill.applicationName
      });
    });

    taskList.forEach( task => {
      delete task.taskId;
    });

    const data = JSON.stringify({
      applicationId: this.popupTableData.applicationid ? this.popupTableData.applicationid : this.popupTableData.applicationId,
      skillList: skillList,
      taskList: taskList
    });

    const requestOptions: APIRequestOptions = {
      responseType: 'blob'
    };

    this.remoteProxy.sendPostRequest( generatePdfReportEndPoint, data, requestOptions)
    .subscribe((response) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      saveAs(blob, this.pdfFilename);
      this.isPdfDownloadInProgress = false;
      this.activeDownloads[skillId].pdf = false;
    }, (error) => {
      console.log(error);
    });
  }

  convertTableArrayIntoString(table) {
    const newTable = [];
    Object.assign(newTable, table);
    for (const row of newTable) {
      for (const cell of row) {
        let text = '';
        if (cell.type === 13) {
          for (const label of cell.title) {
            text = text + ' ' + label.text;
          }
          cell.title = text;
        }
      }
    }
    return newTable;
  }

  copyTable(table) {
    return JSON.parse(JSON.stringify(table));
  }

  updatePopupTableData(data) {
    this.popupTableData = data;
    this.setCurrentSkillId();
  }

  setCurrentSkillId() {
    this.popupTableData.skillList.forEach(skill => {
      this.currentSkillId = skill.skillId;
    });

    if ( !this.activeDownloads[this.currentSkillId] ) {
      this.activeDownloads[this.currentSkillId] = {
        excel: false,
        pdf: false,
      };
    }
  }

  updateDownloadState() {
    if ( this.activeDownloads[this.currentSkillId] && this.activeDownloads[this.currentSkillId].pdf ) {
      this.isPdfDownloadInProgress = true;
    } else {
      this.isPdfDownloadInProgress = false;
    }

    if ( this.activeDownloads[this.currentSkillId] && this.activeDownloads[this.currentSkillId].excel ) {
      this.isExcelDownloadInProgress = true;
    } else {
      this.isExcelDownloadInProgress = false;
    }
  }
}

export enum PopupTableTypes {
  TEXT = 0,
  BUTTON = 1,
  INT = 2,
  DATE = 3,
  LINK = 4,
  CHECK_BOX = 5,
  HIDDEN_ID = 6,
  POPUP = 7,
  HIGHLIGHT_ROW = 8,
  MAIL_TO = 9,
  LINK_ICON = 10,
  IMG_TEXT = 11,
  LINK_IMGLINk_IMGLINK = 12,
  MINMAX_LIST = 13
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/popup-table/popup-table.component.ts